import { render } from "./roadmapSelect.vue?vue&type=template&id=0b9c706c"
import script from "./roadmapSelect.vue?vue&type=script&lang=js"
export * from "./roadmapSelect.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__